module.exports = __webpack_public_path__ + "static/media/especialistas_testimonios6.d3f0620e.jpeg";